var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arp-bpm d-flex flex-row justify-end"},[_c('az-bpm-action',{staticClass:"bpm-action-pedido",attrs:{"before-action":_vm.beforeAction,"after-action":_vm.afterAction,"business-key":_vm.chaveDeNegocio,"button-attrs":{
			claim: {
				class: _vm.getClassButton('claim', ("text-none order-0 text-uppercase " + _vm.botaoClasse)),
				outlined: true,
			},
			unclaim: {
				class: _vm.getClassButton(
					'unclaim',
					("text-none order-1 ms-3 text-uppercase v-btn--width-auto " + _vm.botaoClasse)
				),
				text: true,
			},
			complete: {
				class: _vm.getClassButton('complete', ("text-none order-0 text-uppercase " + _vm.botaoClasse)),
				outlined: true,
			},
			uncomplete: {
				class: _vm.getClassButton('uncomplete', ("text-none order-1 ms-3 text-uppercase " + _vm.botaoClasse)),
				text: true,
			},
		},"process-key":_vm.process_key},scopedSlots:_vm._u([{key:"claim",fn:function(ref){
		var button = ref.button;
return [(false)?_c('span',[_vm._v(_vm._s(button.label))]):_vm._e()]}},{key:"unclaim",fn:function(ref){
		var button = ref.button;
return [_c('icone-tooltip',{attrs:{"tamanho":"auto","icone":"mdi-undo-variant","texto":button.label,"cor":"white"}})]}},{key:"uncomplete",fn:function(ref){
		var button = ref.button;
return [_c('icone-tooltip',{attrs:{"tamanho":"auto","icone":"mdi-undo-variant","texto":button.label,"cor":"white"}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }